import { request } from "@/utils/request";
import {
  IP
} from "@/services/config.js";

/**
 * 会话列表（新）/ly/conversation/list
 * @param {*} data { medmstrId, professionalId, pageNum, pageSize }
 */
export function conversationListLy(data) {
  return request({
    url: `/ly/conversation/list`,
    method: "POST",
    data,
  });
}

/**
 * 会话详情（新）/ly/conversation/detail
 * @param {*} params { conversationId }
 */
export function conversationDetailLy(params) {
  return request({
    url: `/ly/conversation/detail`,
    method: "POST",
    data: params,
  });
}

/**
 * 发送消息（新）/ly/conversation/send
 * @param {*} data { chatId, message, professionalId, departmentId, audioFilePath }
 */
export function sendMessageLy(data) {
  return request({
    url: `/ly/conversation/send`,
    method: "POST",
    data,
  });
}

/**
 * 创建会话（新）/ly/conversation/create
 * @param {*} data { medmstrId, professionalId }
 */
export function createConversationLy(data) {
  return request({
    url: `/ly/conversation/create`,
    method: "POST",
    data,
  });
}

/**
 * 查询会话列表
 * @param {*} data
 * @returns
 */
export function selectListApi(data) {
  return request({
    url: `/admin/conversation/selectList`,
    method: "POST",
    data,
  });
}

/**
 * 新增会话
 * @param {*} data
 * @returns
 */
export function addApi(data) {
  return request({
    url: `/admin/conversation/add`,
    method: "POST",
    data,
  });
}


/**
 * 修改会话
 * @param {*} data
 * @returns
 */
export function updateApi(data) {
  return request({
    url: `/admin/conversation/update`,
    method: "POST",
    data,
  });
}


/**
 * 查询会话详情
 * @param {*} data
 * @returns
 */
export function selectApi(data) {
  return request({
    url: `/admin/conversation/selectDetails`,
    method: "POST",
    data,
  });
}



/**
 * 删除
 * @param {*} data
 * @returns
 */
export function deleteApi(data) {
  return request({
    url: `/admin/conversation/delete`,
    method: "POST",
    data,
  });
}




/**
 * 存入录音
 * @param {*} data
 * @returns
 */
export function writeFiles(data) {
  return new Promise((resolve, reject) => {
    let formData = new FormData();
    formData.append("formData", data);
    // 创建一个AJAX请求上传文件
    const xhr = new XMLHttpRequest();
    xhr.open("POST", IP + "/public/writeFiles/create", true);
    xhr.onload = async (res) => {
      if (res.currentTarget.status === 200) {
        resolve(JSON.parse(xhr.response));
      } else {
        reject(xhr);
        console.error("上传失败", res);
      }
    };
    xhr.send(formData);
  })
  // const formData = new FormData();
  // formData.append('formData', data); // 假设后端期望接收名为'formData'的字段
  // console.log("data", data, formData)
  // return request({
  //   url: `/public/writeFiles/create`,
  //   headers: {
  //     'Content-Type': 'multipart/form-data' // 确保设置正确的Content-Type，axios会自动设置boundary，无需手动设置
  //   },
  //   // responseType: 'blob', // 确保axios返回的是blob类型的数据
  //   method: "POST",
  //   formData,
  //   data:{},
  //   isDecrypt: false,
  //   isEncrypt: false,
  // });

}


/**
 * 语音识别
 * @param {*} data
 * @returns
 */
export function speechRecognition(data) {
  return request({
    url: `/admin/conversation/speechRecognition`,
    method: "POST",
    data,
    isDecrypt: false,
    isEncrypt: true,
  });
}



/* 医生与ai */

/**
 * 新增会话
 * @param {*} data
 * @returns
 */
export function createApi(data) {
  return request({
    url: `/admin/createConversation/create`,
    method: "POST",
    data,
    isDecrypt: false,
    isEncrypt: true,
  });
}

/**
 * 查询会话列表
 * @param {*} data
 * @returns
 */
export function selectListApi_doctor(data) {
  return request({
    url: `/admin/createConversation/selectList`,
    method: "POST",
    data,
  });
}

/**
 * 查询会话详情
 * @param {*} data
 * @returns
 */
export function selectApi_doctor(data) {
  return request({
    url: `/admin/createConversation/selectDetails`,
    method: "POST",
    data,
  });
}

/**
 * 查询会话详情
 * @param {*} data
 * @returns
 */
export function deleteApi_doctor(data) {
  return request({
    url: `/admin/createConversation/delete`,
    method: "POST",
    data,
  });
}
